import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { SlapService } from './slap.service';

@Injectable()
export class SlapGuard implements CanActivate {

    constructor(
        private slapService: SlapService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.slapService.getSlap(this.applicationService.caseId).pipe(map(() => true));
    }
}
